import React from "react";
import {  ThemeProvider, DefaultTheme } from "styled-components";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import usePeristedState from "./services/usePersistedState";
import { light } from "./styles/themes/light";
import { dark } from "./styles/themes/dark";
import GlobalStyle from "./styles/global";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./components/Header";
import Login from "./pages/Login";
import Home from "./pages/home";
import Feriado from "./pages/Feriado";
import Person from "./pages/Person";
import Dimep from "./pages/Dimep";
import PontoTxt from "./pages/PontoTxt";
import NoMatchPage from "./pages/NoMatchPage";
import { isAuthenticated } from "./utils/helpers";

import './App.css';
import 'react-perfect-scrollbar/dist/css/styles.min.css';

function App() {
  const [theme, setTheme] = usePeristedState<DefaultTheme>("theme", light);

  const toggleTheme = () => {
    setTheme(theme.title === "light" ? dark : light);
  };
  const Authenticated = () => {
    return isAuthenticated();
  };

  return (
    <div className="App-header">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          {Authenticated() ? <Header toggleTheme={toggleTheme} /> : ''}
          <Routes>
            <Route path="/" element={Authenticated() ? <Home /> : <Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/home" element={Authenticated() ? <Home /> : ''}/>
            <Route path="/feriado" element={Authenticated() ? <Feriado /> : ''}/>
            <Route path="/person" element={Authenticated() ? <Person /> : ''}/>
            <Route path="/dimep" element={Authenticated() ? <Dimep /> : ''}/>
            <Route path="/pontotxt" element={Authenticated() ? <PontoTxt /> : ''}/>
            <Route path="*" element={<NoMatchPage />} />
          </Routes>
               
          <ToastContainer
            style={{ width: "500px", fontSize: '16px' }}
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            icon={false}
            pauseOnHover
            theme="colored"
          />
        </ThemeProvider>
      </BrowserRouter>
  
    </div>
  );
}

export default App;
